/**
 * Presentation for the chat console's in-app notification types (public.notifications, served by
 * portal, module_key ERPBOI_CHAT).
 *
 * `notif_type` is a free varchar on purpose: a new producer can raise a new type without a back-end
 * release. These maps only decorate the known ones; anything unrecognised falls back to
 * DEFAULT_NOTIF_*. CHAT_MENTION (an @mention while you had no live socket) is written under
 * module_key ERPBOI_CHAT, and portal shows a bell row only under the token's app, so this console's
 * bell is the only one that receives it. The other consoles show mentions through the Chat
 * launcher's "@" instead.
 */
export const NOTIF_TYPE_LABEL: {[key: string]: string} = {
  CHAT_MENTION: 'Mentioned in chat',
}

export const NOTIF_TYPE_TONE: {[key: string]: string} = {
  CHAT_MENTION: 'primary',
}

export const NOTIF_TYPE_ICON: {[key: string]: string} = {
  CHAT_MENTION: 'alternate_email',
}

export const DEFAULT_NOTIF_TONE = 'secondary'
export const DEFAULT_NOTIF_ICON = 'notifications'

export const NOTIF_TYPE_OPTIONS = Object.keys(NOTIF_TYPE_LABEL).map((id) => ({
  id,
  title: NOTIF_TYPE_LABEL[id],
}))

export const notifTone = (notifType?: string) => NOTIF_TYPE_TONE[notifType || ''] || DEFAULT_NOTIF_TONE
export const notifIcon = (notifType?: string) => NOTIF_TYPE_ICON[notifType || ''] || DEFAULT_NOTIF_ICON
export const notifLabel = (notifType?: string) => NOTIF_TYPE_LABEL[notifType || ''] || notifType || '—'
